"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _useTranslation2 = require("../../../hooks/useTranslation/useTranslation");
var currencyCodes = ['AED', 'AFN', 'ALL', 'AMD', 'ANG', 'AOA', 'ARS', 'AUD', 'AWG', 'AZN', 'BAM', 'BBD', 'BDT', 'BGN', 'BHD', 'BIF', 'BMD', 'BND', 'BOB', 'BRL', 'BSD', 'BTN', 'BWP', 'BYN', 'BZD', 'CAD', 'CDF', 'CHF', 'CLP', 'CNY', 'COP', 'CRC', 'CUC', 'CVE', 'CZK', 'DJF', 'DKK', 'DOP', 'DZD', 'EGP', 'ERN', 'ETB', 'EUR', 'FJD', 'FKP', 'GBP', 'GEL', 'GHS', 'GIP', 'GMD', 'GNF', 'GTQ', 'GYD', 'HKD', 'HNL', 'HRK', 'HTG', 'HUF', 'IDR', 'ILS', 'INR', 'IQD', 'IRR', 'ISK', 'JMD', 'JOD', 'JPY', 'KES', 'KGS', 'KHR', 'KMF', 'KPW', 'KRW', 'KWD', 'KYD', 'KZT', 'LAK', 'LBP', 'LKR', 'LRD', 'LSL', 'LYD', 'MAD', 'MDL', 'MGA', 'MKD', 'MMK', 'MNT', 'MOP', 'MRO', 'MUR', 'MVR', 'MWK', 'MXN', 'MYR', 'MZN', 'NAD', 'NGN', 'NIO', 'NOK', 'NPR', 'NZD', 'OMR', 'PAB', 'PEN', 'PGK', 'PHP', 'PKR', 'PLN', 'PYG', 'QAR', 'RON', 'RSD', 'RUB', 'RWF', 'SAR', 'SBD', 'SCR', 'SDG', 'SEK', 'SGD', 'SHP', 'SLL', 'SOS', 'SRD', 'SSP', 'STD', 'SVC', 'SYP', 'SZL', 'THB', 'TJS', 'TMT', 'TND', 'TOP', 'TRY', 'TTD', 'TWD', 'TZS', 'UAH', 'UGX', 'USD', 'UYU', 'UZS', 'VEF', 'VND', 'VUV', 'WST', 'YER', 'ZAR', 'ZMW', 'ZWL'];
var useCurrencies = function useCurrencies(popularCurrencies, allowedCurrencies, hidePopularCurrencies) {
  var _useTranslation = (0, _useTranslation2.useTranslation)(),
    t = _useTranslation.t;
  var formatOptionCurrency = (0, _react.useCallback)(function (value) {
    return "".concat(t("currencies.".concat(value)), " (").concat(value, ")");
  }, [t]);
  var currencies = allowedCurrencies && allowedCurrencies.length > 0 ? allowedCurrencies : currencyCodes;
  popularCurrencies = hidePopularCurrencies ? [] : popularCurrencies;
  return (0, _react.useMemo)(function () {
    return {
      popular: popularCurrencies.map(function (code) {
        return {
          value: code,
          label: formatOptionCurrency(code)
        };
      }),
      other: currencies.filter(function (code) {
        return popularCurrencies.indexOf(code) === -1;
      }).map(function (code) {
        return {
          value: code,
          label: formatOptionCurrency(code)
        };
      })
    };
  }, [popularCurrencies, currencies, formatOptionCurrency]);
};
var _default = useCurrencies;
exports.default = _default;